const theme = {
  red: '#f00',
  green: '#0f0',
  blue: '#00f',
};

export default theme;
